import { EntityStatusBadgeVariant } from '@frontend/common';
import { UserState } from '@frontend/user/types';
import React from 'react';

import { UserStateBadgeProps } from './user-state-badge.component';

interface ViewProps {
    displayName: React.ReactNode;
    variant: EntityStatusBadgeVariant;
}

export const useUserStateBadge = (props: UserStateBadgeProps): ViewProps => {
    return {
        displayName: UserState.getByValue(props.state)?.displayName || 'Unknown',
        variant: UserState.getBadgeVariant(props.state)
    };
};
